import { combineReducers } from '@reduxjs/toolkit';
import { GlobalRouter } from '@okapi/router-react';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { featuresReducer } from 'features';
import { initReducer } from './utils';
import { Env } from './types';

export const rootReducer = ({
                              cookie,
                              env,
                              globalRouter,
                              host,
                              userAgent,
                              isBot = false,
                            }: {
  cookie: string;
  env: Env;
  globalRouter: GlobalRouter;
  host: string | null;
  userAgent: string | null;
  isBot?: boolean;
}) =>
    combineReducers({
      app: featuresReducer,
      cookie: initReducer(cookie),
      env: initReducer(env),
      host: initReducer(host),
      router: createRouterReducer(globalRouter),
      userAgent: initReducer(userAgent),
      isBot: initReducer(isBot),
    });

export type RootReducer = ReturnType<ReturnType<typeof rootReducer>>;